import React, { Component, createElement } from "react";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "whatwg-fetch";
import BulletboardCreateItemForm from "./BulletboardCreateItemForm";
export default class BulletboardCreateItemWrapper extends Component {
	constructor(props) {
		super(props);

		this.state = {
			vogMessage: window.pp_bulletboard_vars.vogMessage,
			successMessage: null,
			errorMessage: null,
			targetAudience: window.pp_bulletboard_vars.targetAudience,
			cities: window.pp_bulletboard_vars.cities,
			recaptchaKey: window.pp_bulletboard_vars.recaptchaKey,
			addNewItemNonce: window.pp_bulletboard_vars.addNewItemNonce,
			archivePageUrl: window.pp_bulletboard_vars.archivePageUrl
		};
	}

	componentDidMount() {}

	submitForm(values) {
		return new Promise((resolve, reject) => {
			const headers = new Headers();
			headers.append("Content-Type", "application/json");

			values["nonce"] = this.state.addNewItemNonce;

			this.setState({
				successMessage: null,
				errorMessage: null
			});

			const JSON_API_URL = `/wp-json/bulletboard/v1/create-item`;

			fetch(JSON_API_URL, {
				method: "post",
				headers,
				body: JSON.stringify(values)
			})
				.then(response => {
					return response.json();
				})
				.then(data => {
					if (data.success) {
						this.setState({ successMessage: data.status });
						resolve();
					} else {
						this.setState({ errorMessage: data.message });
						reject();
					}
				})
				.catch(errors => {
					this.setState({ errorMessage: errors });

					reject();
				});
		});
	}

	retriveData(url, stateKey) {
		fetch(url)
			.then(response => {
				return response.json();
			})
			.then(data => this.setState({ [stateKey]: data }));
	}

	render() {
		if (
			!window.pp_bulletboard_vars.recaptchaKey ||
			window.pp_bulletboard_vars.recaptchaKey === ""
		) {
			return <div className="message">Stel een google recaptcha key in!</div>;
		}

		return (
			<GoogleReCaptchaProvider
				reCaptchaKey={window.pp_bulletboard_vars.recaptchaKey}
				container={{
					element: "recaptcha__wrap",
					parameters: {
						badge: "inline"
					}
				}}
			>
				<BulletboardCreateItemForm
					recaptchaKey={window.pp_bulletboard_vars.recaptchaKey}
					vogMessage={this.state.vogMessage}
					archivePageUrl={this.state.archivePageUrl}
					errorMessage={this.state.errorMessage}
					successMessage={this.state.successMessage}
					cities={this.state.cities}
					targetAudience={this.state.targetAudience}
					onSubmit={values => this.submitForm(values)}
				></BulletboardCreateItemForm>
			</GoogleReCaptchaProvider>
		);
	}
}

document.addEventListener("DOMContentLoaded", () => {
	let el = document.querySelector(".bulletboard__form__add-item");

	if (el === null) {
		return;
	}

	ReactDOM.render(createElement(BulletboardCreateItemWrapper, el.dataset), el);
});
